<template>
    <div class="mainpage">
        <div class="whitebox">
            <h1>Reset Password</h1>
            <ul>
                <li class="t_center">Please check out the verification code we sent to your registration email.</li>
            </ul>
            <el-form :rules="rules" :model="account" ref="ruleForm" style="padding: 5px 0 0 0;font-size: 14px">
                <el-form-item prop="email" style="width: 100%;height: auto;">
                    <input placeholder="Email address" v-model.trim="account.email" type="email"
                           @keydown.enter="check" style="width: 70%"><button type="button" @click="getCode" style="width: 30%;font-size: 15px">Get code</button>
                </el-form-item>

                <el-form-item prop="code" style="width: 100%;height: auto;">
                    <input placeholder="Verification code" v-model.trim="account.code"
                           @keydown.enter="check">
                </el-form-item>

                <el-form-item prop="password" style="width: 100%;height: auto;">
                    <input placeholder="Set a new password" type="password" v-model.trim="account.password"
                           @keydown.enter="check">
                </el-form-item>

                <el-form-item prop="rePassword" style="width: 100%;height: auto;">
                    <input placeholder="Confirm new password" type="password" v-model.trim="account.rePassword"
                           @keydown.enter="check">
                </el-form-item>
                <button type="button" @click="check">Continue</button>
            </el-form>
        </div><!--whitebox end--->
    </div><!--mainpage end--->
</template>
<script>
    import util from '../util';
    import config from '../config';
    import { Message } from 'element-ui'

    export default {
        name: "rest_password",
        data() {
            let account={email:'',code:'',password:'',rePassword:''}
            let checkPassword = function(rule, value, callback){
                if(account.password==account.rePassword)
                    callback()
                else
                    callback(new Error('Passwords don\'t match'))
            }
            return {
                account,
                rules: {
                    email: [{type: "email", message: 'Email invalid format', trigger: 'blur'},
                        {required: true, message: 'Email Can\'t be empty', trigger: 'blur'}],
                    password: [{required: true, message: 'Can\'t be empty', trigger: 'blur'}],
                    rePassword:[{required: true, message: 'Can\'t be empty', trigger: 'blur'},
                        { validator: checkPassword, trigger: 'blur' }]
                }
            }
        },
        methods: {
            getCode(){
                this.$refs.ruleForm.validateField('email',v=>{
                    if(!v)
                        util.axios.post(config.forgot_url, this.account).then(() => {
                            Message({
                                message: 'Send Successfully!',
                                type: 'success',
                                offset:300,
                                duration:1500,
                                center: true
                            });
                        })
                    else
                        Message({
                            message: v,
                            type: 'error',
                            offset:300,
                            duration:1500,
                            center: true
                        });
                })
            },
            check() {
                this.$refs.ruleForm.validate(v => {
                    if (v) {
                        util.axios.post(config.rest_password_url, this.account).then(data => {
                            if (data && data.user) {
                                this.$store.commit('setUser', data);
                                this.goto();
                            }
                        })
                    }
                })
            },
            goto() {
                this.$router.push('/myaccount');
            }
        }
    }
</script>

<style scoped>

</style>
